export const DEFAULT_MONTHLY_DEPOSIT = 50_000;
